import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'Integrations',
  properties: {},

  statics: {
    breadcrumb: 'Integrations',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/integrations.js